import styled from 'styled-components';

import { Dropdown as SemanticDropdown } from 'semantic-ui-react';

import { Header, Loader as CenteredLoader } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  background-color: white;
  border-radius: 4px;
  border: 1px solid ${(props) => props.theme.color.sidebarBorder};
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

export const ContainerDropwdown = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled(Header)`
  color: ${(props) => props.theme.color.text};
`;

export const Dropdown = styled(SemanticDropdown)`
  &&& {
    width: 200px;
    margin-right: 10px;
  }
`;

export const Message = styled(Header)`
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
`;

export const Loader = styled(CenteredLoader)``;
